import { render } from "./UiPanel.vue?vue&type=template&id=0885d78a&ts=true"
import script from "./UiPanel.vue?vue&type=script&lang=ts"
export * from "./UiPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__